import addAdmissionGroupDirective from 'directives/addAdmissionGroup';
import addAdmissionGroupCtrl from 'directives/addAdmissionGroup/controller';
//
import addAdmissionGroupAttributionSourceDirective from 'directives/addAdmissionGroupAttributionSource';
import addAdmissionGroupAttributionSourceCtrl from 'directives/addAdmissionGroupAttributionSource/controller';
//
import addAdmissionGroupCustomerDirective from 'directives/addAdmissionGroupCustomer';
import addAdmissionGroupCustomerCtrl from 'directives/addAdmissionGroupCustomer/controller';
//
import addVenueLayoutDirective from 'directives/addVenueLayout';
import addVenueLayoutCtrl from 'directives/addVenueLayout/controller';
//
import AdmissionGroupCommissionsDirective from 'directives/admissionGroupCommissions';
import admissionGroupCommissionsCtrl from 'directives/admissionGroupCommissions/controller';
//
import AdmissionGroupReceiptsDirective from 'directives/admissionGroupReceipts';
import admissionGroupReceiptsCtrl from 'directives/admissionGroupReceipts/controller';
//
import BulkAddAdmissionGroupsDirective from 'directives/bulkAddAdmissionGroups';
import bulkAddAdmissionGroupsCtrl from 'directives/bulkAddAdmissionGroups/controller';
//
import BannerDirective from 'directives/banner';
//
import BannerOrgBillingDirective from 'directives/bannerOrgBilling';
import bannerOrgBillingCtrl from 'directives/bannerOrgBilling/controller';
//
import EmbeddedIframeDirective from 'directives/embeddedIframe';
import embeddedIframeCtrl from 'directives/embeddedIframe/controller';
//
import ExportListDirective from 'directives/exportList';
import exportListCtrl from 'directives/exportList/controller';
//
import FeesDirective from 'directives/fees';
import feesCtrl from 'directives/fees/controller';
//
import PerformersDirective from 'directives/performers';
import performersCtrl from 'directives/performers/controller';
//
import MergeAttributionsDirective from 'directives/mergeAttributions';
import mergeAttributionsCtrl from 'directives/mergeAttributions/controller';
//
import MergeAttributionsTableDirective from 'directives/mergeAttributionsTable';
import mergeAttributionsTableCtrl from 'directives/mergeAttributionsTable/controller';
//
import MergeCustomersDirective from 'directives/mergeCustomers';
import mergeCustomersCtrl from 'directives/mergeCustomers/controller';
//
import MergeCustomersTableDirective from 'directives/mergeCustomersTable';
import mergeCustomersTableCtrl from 'directives/mergeCustomersTable/controller';
//
import NpSitePageDirective from 'directives/npSitePage';
//
import PaymentProfileDirective from 'directives/paymentProfile';
import paymentProfileCtrl from 'directives/paymentProfile/controller';
//
import SchedulePickerDirective from 'directives/schedulePicker';
//
import DateAndEventPickerDirective from 'directives/dateAndEventPicker';
//
import LogoPageDirective from 'directives/logoPage';
//
import SidebarDirective from 'directives/sidebar';
import sidebarCtrl from 'directives/sidebar/controller';
//
import TablelistNotEnabledBannerDirective from 'directives/tablelistNotEnabledBanner';
import tablelistNotEnabledBannerCtrl from 'directives/tablelistNotEnabledBanner/controller';
//
import TiersDirective from 'directives/tiers';
import tiersCtrl from 'directives/tiers/controller';
//
import TipNotificationDirective from 'directives/tipNotification';
import tipNotificationCtrl from 'directives/tipNotification/controller';
//
import AddAdmissionGroupWidgetDirective from 'directives/widgets/addAdmissionGroupWidget';
import addAdmissionGroupWidgetCtrl from 'directives/widgets/addAdmissionGroupWidget/controller';
//
import EventCalendarWidgetDirective from 'directives/widgets/eventCalendarWidget';
import eventCalendarWidgetCtrl from 'directives/widgets/eventCalendarWidget/controller';
//
import EventCarouselWidgetDirective from 'directives/widgets/eventCarouselWidget';
import eventCarouselWidgetCtrl from 'directives/widgets/eventCarouselWidget/controller';
//
import EventListWidgetDirective from 'directives/widgets/eventListWidget';
import eventListWidgetCtrl from 'directives/widgets/eventListWidget/controller';
//
import InventoryListWidgetDirective from 'directives/widgets/inventoryListWidget';
import inventoryListWidgetCtrl from 'directives/widgets/inventoryListWidget/controller';
//
import InventoryMapDirective from 'directives/widgets/inventoryMapWidget';
import inventoryMapWidgetCtrl from 'directives/widgets/inventoryMapWidget/controller';
//
import WidgetBuilderDirective from 'directives/widgets/widgetBuilder';
import widgetBuilderCtrl from 'directives/widgets/widgetBuilder/controller';
//
import OnboardingSidebarMenuItemDirective from 'directives/onboardingSidebarMenuItem';
import onboardingSidebarMenuItemCtrl from 'directives/onboardingSidebarMenuItem/controller';
//
import AddInventoryDirective from 'directives/addInventory';
import addInventoryCtrl from 'directives/addInventory/controller';
//
import InventoryListDirective from 'directives/inventoryList';
import inventoryListCtrl from 'directives/inventoryList/controller';
//
import AddEventDirective from 'directives/addEvent';
import addEventCtrl from 'directives/addEvent/controller';
//
import AddMicroSiteConfigDirective from 'directives/addMicroSiteConfig';
import addMicroSiteConfigCtrl from 'directives/addMicroSiteConfig/controller';
//
import CompareToDirective from 'directives/compareTo';
import DraggableDirective from 'directives/draggable';
import DroppableDirective from 'directives/droppable';
import FilePickerDirective from 'directives/filePicker';
import FilePickerDragAndDropDirective from 'directives/filePickerDragAndDrop';
import GiveFocusDirective from 'directives/giveFocus';
import TimepickerDirective from 'directives/timepicker';
import WidgetIframeDirective from 'directives/widgetIframe';
import SelectOnClickDirective from 'directives/selectOnClick';
import FraudStatusDirective from 'directives/fraudStatus';
import KeyEnterEventDirective from 'directives/keyEnterEvent';
import PermissionDisabledDirective from 'directives/permissionDisabled';
import ProfilePicInitialsDirective from 'directives/profilePicInitials';
import UhOhMessageDirective from 'directives/uhOhMessage';
import NpSummernoteDirective from 'directives/npSummernote';
import TrackEventDirective from 'directives/trackEvent';
import PageLoaderDirective from 'directives/pageLoader';
import ToggleBtnDirective from 'directives/toggleBtn';
import VenuePageHeaderDirective from 'directives/venuePageHeader';
import SlideDownDirective from 'directives/slideDown';
import IsolateFormDirective from 'directives/isolateForm';
import MoreMenuDirective from 'directives/moreMenu';
import SetRangeOnFocusDirective from 'directives/setRangeOnFocus';
import OnNumbersDirective from 'directives/onlyNumbers';
import AdmissionGroupStatusLabelDirective from 'directives/admissionGroupStatusLabel';
import AdmissionGroupPaymentStatusLabelDirective from 'directives/admissionGroupPaymentStatusLabel';
import WexCardDirective from 'directives/wexCard';
import PaymentRequestsPanelDirective from 'directives/paymentRequestsPanel';
import BuyerTotalDirective from 'directives/buyerTotal';

function init(app) {
  if (!app) throw new Error('app is required');

  app.directive('addAdmissionGroup', addAdmissionGroupDirective);
  app.controller('addAdmissionGroupCtrl', addAdmissionGroupCtrl);
  //
  app.directive('addAdmissionGroupAttributionSource', addAdmissionGroupAttributionSourceDirective);
  app.controller('addAdmissionGroupAttributionSourceCtrl', addAdmissionGroupAttributionSourceCtrl);
  //
  app.directive('addAdmissionGroupCustomer', addAdmissionGroupCustomerDirective);
  app.controller('addAdmissionGroupCustomerCtrl', addAdmissionGroupCustomerCtrl);
  //
  app.directive('admissionGroupCommissions', AdmissionGroupCommissionsDirective);
  app.controller('admissionGroupCommissionsCtrl', admissionGroupCommissionsCtrl);
  //
  app.directive('admissionGroupReceipts', AdmissionGroupReceiptsDirective);
  app.controller('admissionGroupReceiptsCtrl', admissionGroupReceiptsCtrl);
  //
  app.directive('addVenueLayout', addVenueLayoutDirective);
  app.controller('addVenueLayoutCtrl', addVenueLayoutCtrl);
  //
  app.directive('bulkAddAdmissionGroups', BulkAddAdmissionGroupsDirective);
  app.controller('bulkAddAdmissionGroupsCtrl', bulkAddAdmissionGroupsCtrl);
  //
  app.directive('banner', BannerDirective);
  //
  app.directive('bannerOrgBilling', BannerOrgBillingDirective);
  app.controller('bannerOrgBillingCtrl', bannerOrgBillingCtrl);
  //
  app.directive('dateAndEventPicker', DateAndEventPickerDirective);
  //
  app.directive('embeddedIframe', EmbeddedIframeDirective);
  app.controller('embeddedIframeCtrl', embeddedIframeCtrl);
  //
  app.directive('exportList', ExportListDirective);
  app.controller('exportListCtrl', exportListCtrl);
  //
  app.directive('fees', FeesDirective);
  app.controller('feesCtrl', feesCtrl);
  //
  app.directive('performers', PerformersDirective);
  app.controller('performersCtrl', performersCtrl);
  //
  app.directive('mergeAttributions', MergeAttributionsDirective);
  app.controller('mergeAttributionsCtrl', mergeAttributionsCtrl);
  //
  app.directive('mergeAttributionsTable', MergeAttributionsTableDirective);
  app.controller('mergeAttributionsTableCtrl', mergeAttributionsTableCtrl);
  //
  app.directive('mergeCustomers', MergeCustomersDirective);
  app.controller('mergeCustomersCtrl', mergeCustomersCtrl);
  //
  app.directive('mergeCustomersTable', MergeCustomersTableDirective);
  app.controller('mergeCustomersTableCtrl', mergeCustomersTableCtrl);
  //
  app.directive('npSitePage', NpSitePageDirective);
  //
  app.directive('schedulePicker', SchedulePickerDirective);
  //
  app.directive('paymentProfile', PaymentProfileDirective);
  app.controller('paymentProfileCtrl', paymentProfileCtrl);
  //
  app.directive('logoPage', LogoPageDirective);
  //
  app.directive('sidebar', SidebarDirective);
  app.controller('sidebarCtrl', sidebarCtrl);
  //
  app.directive('tablelistNotEnabledBanner', TablelistNotEnabledBannerDirective);
  app.controller('tablelistNotEnabledBannerCtrl', tablelistNotEnabledBannerCtrl);
  //
  app.directive('tiers', TiersDirective);
  app.controller('tiersCtrl', tiersCtrl);
  //
  app.directive('tipNotification', TipNotificationDirective);
  app.controller('tipNotificationCtrl', tipNotificationCtrl);
  //
  app.directive('addAdmissionGroupWidget', AddAdmissionGroupWidgetDirective);
  app.controller('addAdmissionGroupWidgetCtrl', addAdmissionGroupWidgetCtrl);
  //
  app.directive('eventCalendarWidget', EventCalendarWidgetDirective);
  app.controller('eventCalendarWidgetCtrl', eventCalendarWidgetCtrl);
  //
  app.directive('eventCarouselWidget', EventCarouselWidgetDirective);
  app.controller('eventCarouselWidgetCtrl', eventCarouselWidgetCtrl);
  //
  app.directive('eventListWidget', EventListWidgetDirective);
  app.controller('eventListWidgetCtrl', eventListWidgetCtrl);
  //
  app.directive('inventoryListWidget', InventoryListWidgetDirective);
  app.controller('inventoryListWidgetCtrl', inventoryListWidgetCtrl);
  //
  app.directive('inventoryMapWidget', InventoryMapDirective);
  app.controller('inventoryMapWidgetCtrl', inventoryMapWidgetCtrl);
  //
  app.directive('widgetBuilder', WidgetBuilderDirective);
  app.controller('widgetBuilderCtrl', widgetBuilderCtrl);
  //
  app.directive('onboardingSidebarMenuItem', OnboardingSidebarMenuItemDirective);
  app.controller('onboardingSidebarMenuItemCtrl', onboardingSidebarMenuItemCtrl);
  //
  app.directive('addInventory', AddInventoryDirective);
  app.controller('addInventoryCtrl', addInventoryCtrl);
  //
  app.directive('inventoryList', InventoryListDirective);
  app.controller('inventoryListCtrl', inventoryListCtrl);
  //
  app.directive('addEvent', AddEventDirective);
  app.controller('addEventCtrl', addEventCtrl);
  //
  app.directive('addMicroSiteConfig', AddMicroSiteConfigDirective);
  app.controller('addMicroSiteConfigCtrl', addMicroSiteConfigCtrl);
  //
  app.directive('compareTo', CompareToDirective);
  app.directive('draggable', DraggableDirective);
  app.directive('droppable', DroppableDirective);
  app.directive('filePicker', FilePickerDirective);
  app.directive('filePickerDragAndDrop', FilePickerDragAndDropDirective);
  app.directive('giveFocus', GiveFocusDirective);
  app.directive('timepicker', TimepickerDirective);
  app.directive('widgetIframe', WidgetIframeDirective);
  app.directive('selectOnClick', SelectOnClickDirective);
  app.directive('fraudStatus', FraudStatusDirective);
  app.directive('keyEnterEvent', KeyEnterEventDirective);
  app.directive('permissionDisabled', PermissionDisabledDirective);
  app.directive('profilePicInitials', ProfilePicInitialsDirective);
  app.directive('uhOhMessage', UhOhMessageDirective);
  app.directive('npSummernote', NpSummernoteDirective);
  app.directive('trackEvent', TrackEventDirective);
  app.directive('pageLoader', PageLoaderDirective);
  app.directive('toggleBtn', ToggleBtnDirective);
  app.directive('venuePageHeader', VenuePageHeaderDirective);
  app.directive('slideDown', SlideDownDirective);
  app.directive('isolateForm', IsolateFormDirective);
  app.directive('moreMenu', MoreMenuDirective);
  app.directive('setRangeOnFocus', SetRangeOnFocusDirective);
  app.directive('onlyNumbers', OnNumbersDirective);
  app.directive('admissionGroupStatusLabel', AdmissionGroupStatusLabelDirective);
  app.directive('admissionGroupPaymentStatusLabel', AdmissionGroupPaymentStatusLabelDirective);
  app.directive('wexCard', WexCardDirective);
  app.directive('paymentRequestsPanel', PaymentRequestsPanelDirective);
  app.directive('buyerTotal', BuyerTotalDirective);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/directives/index.js